const baseURL = {
  // DEV: '//rap2api.taobao.org/app/mock/231054/', // rap2
  DEV: 'https://yunnan-cloud-backend-test.wetax.com.cn',
  TEST: 'https://yunnan-cloud-backend-test.wetax.com.cn',
  PREPROD: 'https://yunnan-cloud-backend-uat.wetax.com.cn',
  PROD: 'https://yunnan-cloud-backend.jcsk.cc'
}

export default function getBaseURL(env = APP_ENV) {
  return baseURL[env]
}
